import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { toastActions } from '../../actions'
import { Creators as SiteCreators } from '../../ducks/site/site'

// componentes
import Banner from './components/banner/banner.component'
import Muvicard from './components/card/muvicard.component'
import Historic from './components/historic/historic.component'
import Summary from './components/summary/summary.component'
import { history } from './../../helpers/history'

import { StorageService } from '../../services/storage.service'

import {
	MyCard,
	BoxCard,
	Container,
	MonthCard,
	SummaryBox
} from './styles.style'
import { MuvicardService } from '../../services/muvicard.service'
import Modal from '../../components/modal/modal.component'
import { CardBoxButton } from './components/card/componentes/CardBoxButton/card-box-button.component'
import { navigationOperationConstants, routes } from '../../constants'
class MeuCartaoPage extends Component {
	constructor(props) {
		super(props)

		this.state = {
			name: '',
			notes: '',
			errors: '',
			status: '',
			percent: '',
			isPJ: false,
			isOpen: false,
			loading: false,
			cardStatus: '',
			limitValue: '',
			bankSlipKey: '',
			closingDate: '',
			cardPersonId: '',
			partialValue: '',
			expirationDate: '',
			monthDescription: '',
			selectedCompetence: '',
			originalLimitValue: '',
			invoiceExpirationDay: '',
			extract: [
				{
					year: '',
					value: '',
					month: '',
					operation: '',
					orderNumber: '',
					description: '',
					invoiceStatus: '',
					transactionDate: '',
					monthDescription: '',
					installmentNumber: ''
				}
			],
			invoices: [
				{
					partialValue: 0,
					monthDescription: ''
				}
			]
		}
	}

	convertDate = date => {
		let calendar = new Date(date)
		let day =
			calendar.getDate() > 9 ? calendar.getDate() : '0' + calendar.getDate()
		let month = calendar.getMonth() + 1
		let year = calendar.getFullYear()

		return `${day}/${month > 9 ? month : '0' + month}/${year}`
	}

	componentDidMount() {
		let userStorage = StorageService.authentication.user.get()

		if (!this.props.user) {
			history.push(routes.ENTRAR)
			return
		}

		if (!this.props.user.hasMuvicard && !userStorage.hasMuvicard) {
			history.push(routes.MUVICARD_CADASTRO)
			return
		}

		MuvicardService.GetCardInfo()
			.then(res => {
				this.props.showLoading()
				if (res.success) {
					const {
						isPJ,
						name,
						status,
						limitValue,
						cardPersonId,
						originalLimitValue,
						invoiceExpirationDay
					} = res.data

					let result = originalLimitValue - limitValue
					let cardStatus = status
					this.setState({
						isPJ,
						name,
						limitValue,
						cardStatus,
						cardPersonId,
						originalLimitValue,
						invoiceExpirationDay,
						percent: (result / originalLimitValue) * 100
					})
					this.getFirstInvoiceInfoToShow(cardPersonId)
				}
			})
			.catch(e => {
				this.props.hideLoading()
			})
	}

	getFirstInvoiceInfoToShow = cardPersonId => {
		MuvicardService.GetFirstInvoiceInfoToShow(cardPersonId)
			.then(resInvoice => {
				if (resInvoice.success) {
					const {
						notes,
						status,
						extract,
						competence,
						closingDate,
						bankSlipKey,
						partialValue,
						expirationDate,
						monthDescription
					} = resInvoice.data

					this.setState({
						notes,
						status,
						extract,
						bankSlipKey,
						partialValue,
						loading: true,
						monthDescription,
						selectedCompetence:
							competence || this.calculateDefaultCompetence(),
						closingDate: this.convertDate(closingDate),
						expirationDate: this.convertDate(expirationDate)
					})

					this.props.hideLoading()
					MuvicardService.GetInvoices(cardPersonId).then(
						resInvoiceList => {
							if (resInvoiceList.success) {
								const invoices = resInvoiceList.data
								this.setState({
									invoices: invoices
								})
							} else {
								this.setState({
									invoices: []
								})
							}
						}
					)
				} else {
					this.setState({
						notes: '',
						status: '',
						extract: '',
						invoices: [],
						loading: true,
						closingDate: '',
						partialValue: '',
						expirationDate: '',
						monthDescription: ''
					})
					this.props.hideLoading()
				}
			})
			.catch(e => {
				this.setState({
					notes: '',
					status: '',
					extract: '',
					loading: true,
					closingDate: '',
					partialValue: '',
					expirationDate: '',
					monthDescription: ''
				})
				this.props.hideLoading()
			})
	}

	getInvoiceInfo = (cardPersonId, selectedCompetence) => {
		MuvicardService.GetInvoiceInfo(cardPersonId, selectedCompetence)
			.then(resInvoice => {
				if (resInvoice.success) {
					const {
						notes,
						status,
						extract,
						closingDate,
						bankSlipKey,
						partialValue,
						expirationDate,
						monthDescription
					} = resInvoice.data
					this.setState({
						notes,
						status,
						extract,
						bankSlipKey,
						partialValue,
						loading: true,
						monthDescription,
						selectedCompetence,
						closingDate: this.convertDate(closingDate),
						expirationDate: this.convertDate(expirationDate)
					})

					this.props.hideLoading()
					MuvicardService.GetInvoices(cardPersonId).then(
						resInvoiceList => {
							if (resInvoiceList.success) {
								const invoices = resInvoiceList.data
								this.setState({
									invoices: invoices
								})
							} else {
								this.setState({
									invoices: []
								})
							}
						}
					)
				} else {
					this.setState({
						notes: '',
						status: '',
						extract: '',
						invoices: [],
						loading: true,
						closingDate: '',
						partialValue: '',
						expirationDate: '',
						monthDescription: ''
					})
					this.props.hideLoading()
				}
			})
			.catch(e => {
				this.setState({
					notes: '',
					status: '',
					extract: '',
					loading: true,
					closingDate: '',
					partialValue: '',
					expirationDate: '',
					monthDescription: ''
				})
				this.props.hideLoading()
			})
	}

	calculateDefaultCompetence = () => {
		const date = new Date()
		let month = (date.getMonth() + 1).toString().padStart(2, '0')
		let year = date.getFullYear()
		return `${year}${month}`
	}

	calculateNewCompetence = (operation, selectedCompetence) => {
		let newCompetence
		let year = parseInt(selectedCompetence.toString().substring(0, 4))
		let month = parseInt(selectedCompetence.toString().substring(4, 6))
		if (operation === navigationOperationConstants.PREVIOUS) {
			if (month == 1) {
				year -= 1
				month = 12
			} else {
				month -= 1
			}
		} else {
			if (month == 12) {
				year += 1
				month = 1
			} else {
				month += 1
			}
		}
		month = month.toString().padStart(2, '0')
		newCompetence = `${year}${month}`
		return newCompetence
	}

	handleChangeCompetence = operation => {
		const { selectedCompetence, cardPersonId } = this.state
		let newCompetence = this.calculateNewCompetence(
			operation,
			selectedCompetence
		)
		this.getInvoiceInfo(cardPersonId, newCompetence)
	}

	render() {
		const {
			isPJ,
			name,
			notes,
			isOpen,
			status,
			errors,
			percent,
			extract,
			loading,
			invoices,
			limitValue,
			cardStatus,
			bankSlipKey,
			closingDate,
			partialValue,
			expirationDate,
			monthDescription,
			originalLimitValue,
			selectedCompetence,
			invoiceExpirationDay
		} = this.state

		const { showLoading, hideLoading } = this.props
		const invoiceExistsForCurrentMonth =
			extract != undefined && extract.length > 0

		return (
			<React.Fragment>
				{loading ? (
					<Container className="principal">
						<Banner />
						<MyCard className="my-card">
							<MonthCard>{monthDescription}</MonthCard>
							<BoxCard className="box-card">
								<Muvicard
									isPJ={isPJ}
									name={name}
									status={status}
									percent={percent}
									invoices={invoices}
									cardStatus={cardStatus}
									limitValue={limitValue}
									bankSlipKey={bankSlipKey}
									showLoading={showLoading}
									hideLoading={hideLoading}
									closingDate={closingDate}
									partialValue={partialValue}
									expirationDate={expirationDate}
									monthDescription={monthDescription}
									originalLimitValue={originalLimitValue}
									selectedCompetence={selectedCompetence}
									invoiceExpirationDay={invoiceExpirationDay}
									invoiceExists={invoiceExistsForCurrentMonth}
									onChangeCompetence={this.handleChangeCompetence}
								/>
								<Historic
									notes={notes}
									extract={extract}
									monthDescription={monthDescription}
									invoiceExists={invoiceExistsForCurrentMonth}
								/>
							</BoxCard>

							<CardBoxButton
								title="Ver resumo de todas as faturas"
								text="Ver resumo de todas as faturas"
								handleClick={() => this.setState({ isOpen: true })}
							/>
						</MyCard>
						<Modal
							noPadding
							animation="fadeIn"
							isOpen={isOpen}
							onClose={() => this.setState({ isOpen: false })}>
							<SummaryBox>
								<Summary
									invoices={invoices}
									partialValue={partialValue}
									monthDescription={monthDescription}
								/>
								<footer className="footer-modal">
									<button
										className="lk-resume"
										onClick={() => this.setState({ isOpen: false })}>
										Voltar para meu cartão
									</button>
								</footer>
							</SummaryBox>
						</Modal>
					</Container>
				) : errors ? (
					<div
						className="errors"
						style={{
							padding: '100px',
							textAlign: 'center',
							fontSize: '18px'
						}}>
						{errors}
					</div>
				) : (
					''
				)}
			</React.Fragment>
		)
	}
}

const mapStateToProps = store => ({
	user: store.user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			toastError: toastActions.danger,
			toastSuccess: toastActions.success,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedMeuCartaoPage = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(MeuCartaoPage)
)
export { connectedMeuCartaoPage as ModuleRootComponent }
